import React from 'react'
import AdminEditProfileFormPage from '../../components/Admin/EditProfileForm';

const EditProfileForm = () => {
  return (
    <AdminEditProfileFormPage />
  )
}

export default EditProfileForm;


